import { ProjectType } from '../../../../types/project';
import type { FileFormat } from '../../types';
import ExportAccordion from '../ExportAccordion';
import CustomStatusInput from './components/CustomStatusInput';
import DataRangeInput from './components/DataRangeInput';
import FilterByFileNameInput from './components/FilterByFileNameInput';
import TagsInput from './components/TagsInput';
import { Container } from './styles';
import type { Value } from './types';

interface FilterDataProps {
    value: Value;
    fileFormat: FileFormat;
    projectType: ProjectType;
    isCustomTranslationStatusesAvailable: boolean;
    switchIncludeAll: boolean;
    projectId: string;
    onChange: (value: Value) => void;
}

const FilterData = ({
    value,
    fileFormat,
    projectType,
    isCustomTranslationStatusesAvailable,
    switchIncludeAll,
    projectId,
    onChange,
}: FilterDataProps) => (
    <ExportAccordion heading={<b>Content to export</b>} name="content-to-export" projectId={projectId}>
        <Container>
            {projectType === ProjectType.localizationFiles && (
                <>
                    <DataRangeInput
                        value={{
                            exportAll: value.exportAll,
                            exportGlastReviewed: value.exportGlastReviewed,
                            exportGnonfuzzy: value.exportGnonfuzzy,
                            exportGnonhidden: value.exportGnonhidden,
                            exportGproofread: value.exportGproofread,
                            exportGtranslated: value.exportGtranslated,
                            exportGuntranslated: value.exportGuntranslated,
                        }}
                        onChange={(val) =>
                            onChange({
                                ...value,
                                ...val,
                            })
                        }
                    />
                    <TagsInput
                        label="Include tags"
                        value={value.includeTags}
                        hint="Only keys with specified tags will be included in the bundle. Leave empty to include all keys."
                        onChange={(includeTags) =>
                            onChange({
                                ...value,
                                includeTags,
                            })
                        }
                    />
                    <TagsInput
                        label="Exclude tags"
                        value={value.excludeTags}
                        hint="Keys with specified tags will not be included in the bundle."
                        onChange={(excludeTags) =>
                            onChange({
                                ...value,
                                excludeTags,
                            })
                        }
                    />
                </>
            )}
            <FilterByFileNameInput
                fileFormat={fileFormat}
                switchIncludeAll={switchIncludeAll}
                value={value.filterFilenames}
                onChange={(filterFilenames) =>
                    onChange({
                        ...value,
                        filterFilenames,
                    })
                }
            />
            {isCustomTranslationStatusesAvailable && projectType === ProjectType.localizationFiles && (
                <CustomStatusInput
                    value={value.customTranslationStatusIds}
                    onChange={(customTranslationStatusIds) =>
                        onChange({
                            ...value,
                            customTranslationStatusIds,
                        })
                    }
                />
            )}
        </Container>
    </ExportAccordion>
);

export default FilterData;
